import { render } from "./QRcode.vue?vue&type=template&id=2b0812dc&scoped=true"
import script from "./QRcode.vue?vue&type=script&lang=js"
export * from "./QRcode.vue?vue&type=script&lang=js"

import "./QRcode.vue?vue&type=style&index=0&id=2b0812dc&scoped=true&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/pro-base3-fe-portal-old1/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b0812dc"]])

export default __exports__